import React from 'react';
import { motion } from 'framer-motion';
import { History, Trash2, Clock, Search as SearchIcon } from 'lucide-react';
import { useSearchStore } from '../stores/searchStore';
import { format } from 'date-fns';

interface SearchHistoryProps {
  onSelect: (query: string) => void;
}

export const SearchHistory: React.FC<SearchHistoryProps> = ({ onSelect }) => {
  const { getRecentSearches, clearHistory } = useSearchStore();
  const recentSearches = getRecentSearches(10);

  if (!recentSearches.length) {
    return (
      <div className="text-center py-12">
        <SearchIcon className="w-12 h-12 text-zinc-600 mx-auto mb-4" />
        <h2 className="text-xl font-semibold mb-2">No recent searches</h2>
        <p className="text-zinc-400">Your search history will appear here</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <History className="w-5 h-5" />
          Recent Searches
        </h2>
        <button
          onClick={clearHistory}
          className="flex items-center gap-2 px-3 py-1 text-sm text-zinc-400 hover:text-white transition"
        >
          <Trash2 className="w-4 h-4" />
          Clear History
        </button>
      </div>

      <div className="space-y-2">
        {recentSearches.map((item, index) => (
          <motion.button
            key={item.timestamp}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            onClick={() => onSelect(item.query)}
            className="w-full p-4 bg-zinc-800/50 rounded-lg hover:bg-zinc-800 transition group"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="font-medium">{item.query}</span>
              <span className="text-sm text-zinc-500 flex items-center gap-1">
                <Clock className="w-3 h-3" />
                {format(item.timestamp, 'MMM d, h:mm a')}
              </span>
            </div>
            <div className="flex items-center gap-4 text-sm text-zinc-400">
              <span className="capitalize">{item.provider}</span>
              <span>•</span>
              <span>{item.resultCount} results</span>
            </div>
          </motion.button>
        ))}
      </div>
    </div>
  );
};